import { render, staticRenderFns } from "./EstatisticasCampanha.vue?vue&type=template&id=6f6e33ae&scoped=true&"
import script from "./EstatisticasCampanha.vue?vue&type=script&lang=js&"
export * from "./EstatisticasCampanha.vue?vue&type=script&lang=js&"
import style0 from "./EstatisticasCampanha.vue?vue&type=style&index=0&id=6f6e33ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e33ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
